import React, { Component } from "react";
import $ from 'jquery';
import {menuOpen, sideMenuOpen, sideMenuClose, MENU_ITEMS , CONFIG} from '../helpers/Common'
 
class Menu extends Component {
  constructor(props)
  {
    super(props);
  }

  componentDidMount()
  {
    $(function () {
        $('body').on('click', '.nav-icon', function () {
            menuOpen();
        }).on('click', '.js-sideMenu:not(.is--active)', function () {
            sideMenuOpen();
        }).on('click', '.js-sideMenu.is--active', function () {
            sideMenuClose();
        }).on('click', '.js-sideMenu-close', function () {
            sideMenuClose();
        }).on('click touchstart', '.js-defaultOverlay', function () {
            sideMenuClose();
        });
    });
  }

  render() {
    return (
        <React.Fragment>
        <div className="c-side-nav">
            <div className="bg-side-overlay"></div>
            <a href="javascript:;" className="btnBack js-sideMenu-close">
                <img src="assets/img/icons/ic-close.svg" alt="" className="tosvg" />
                <span>{CONFIG.Close}</span>
            </a>
            <div className="c-side-menu">
                <div className="c-menuWrapper">
                    <ul className="c-menuList">
                        <li>
                            <a href="javascript:;">
                                <span>{MENU_ITEMS.Pending_Narratives}</span>
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <span>{MENU_ITEMS.My_Profile}</span>
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <span>{MENU_ITEMS.Settings}</span>
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <span>{MENU_ITEMS.Logout}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="defaultOverlay js-defaultOverlay"></div>
        </React.Fragment>
    );
  }
}

export default Menu;
